import React, { useEffect } from "react";
import { NotebookPen } from "lucide-react";

export const DIARY_UNLOCK_KEY = "rl_diary_unlock_seen_v1";

export default function DiaryUnlockOverlay({ onClose }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DIARY_UNLOCK_KEY, "1"); } catch {}
    if (onClose) onClose();
  };

  const openDiary = () => {
    try { localStorage.setItem(DIARY_UNLOCK_KEY, "1"); } catch {}
    if (onClose) onClose("open");
  };

  return (
    <div className="fixed inset-0 z-[2147483648] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative w-full max-w-md rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-xl">
        <div className="p-5">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Your First Unlock!</h2>
            <span className="ml-3 inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700">New</span>
          </div>
          <ul className="mt-4 space-y-3 text-sm text-slate-800 dark:text-slate-100 list-disc pl-5">
            <li className="marker:text-teal-500">
              Diary function has been unlocked. Find it in the top-right menu under <span className="inline-flex items-center gap-1"><NotebookPen className="h-4 w-4 text-white" /> Diary</span>.
            </li>
          </ul>

          <div className="mt-5 flex justify-end gap-2">
            <button type="button" onClick={dismiss} className="text-sm px-4 py-2 rounded-md border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800">Maybe later</button>
            <button type="button" onClick={openDiary} className="text-sm px-4 py-2 rounded-lg bg-teal-800 text-white hover:bg-teal-900">Open Diary</button>
          </div>
        </div>
      </div>
    </div>
  );
}